import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
`

export const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 5px;
    width: 100%;
    float: left;
`

export const Column = styled.div`
    border-radius: 8px;
    background-color: #FFFFFF;
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const Time = styled.div`
    font-size: 26px;
    margin-bottom: 0;
    font-weight: 900;
    color: #000;

    @media (max-width: 600px) {
        font-size: 20px;
    }
`

export const Label = styled.div`
    font-size: 11px;
    color: #000;

    @media (max-width: 650px) {
        font-size: 10px;
    }
`